import React from "react";
import CONFIG from "../../../model/TSConfig";
import { KC_CardImageProps } from "./model/KC_CardImageProps";

export const KC_CardImage: React.FC<KC_CardImageProps> = (props) => (
  <img
    alt={`${props.title || "Card"} image`}
    id={props.imgId}
    data-twic-src={props.image}
    data-src-transform={"contain=WxH/quality=100"}
    src={props.useTwicpic ? CONFIG.image_placeholder_url : props.image}
  />
);
